<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()"><a-icon type="plus" />新增</a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete"><a-icon type="delete" />删除</a-button>
      </div>
      <create-form ref="createForm" @ok="getList" />
      <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false" :bordered="tableBordered">
        <span slot="isDefault" slot-scope="text, record">
          <a-tag v-if="record.isDefault" color="green">是</a-tag>
          <a-tag v-else>否</a-tag>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-switch :checked="record.status === 1" @change="(checked) => handleStatusChange(record, checked)" />
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record)"><a-icon type="edit" />修改</a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)"><a-icon type="delete" />删除</a>
        </span>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { listAddress, delAddress, updateAddress } from '@/api/cloudplant/address'
import { tableMixin } from '@/store/table-mixin'
import CreateForm from './modules/CreateForm'

export default {
  name: 'PlatformAddress',
  mixins: [tableMixin],
  components: { CreateForm },
  data() {
    return {
      list: [], loading: false, selectedRowKeys: [], multiple: true, queryParam: {},
      columns: [
        { title: '联系人', dataIndex: 'contactName', align: 'center' },
        { title: '联系电话', dataIndex: 'contactPhone', align: 'center' },
        { title: '收货地址', dataIndex: 'address', align: 'center' },
        { title: '是否默认', dataIndex: 'isDefault', scopedSlots: { customRender: 'isDefault' }, align: 'center', width: 100 },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center', width: 100 },
        { title: '操作', dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, align: 'center', width: 150 }
      ]
    }
  },
  created() { this.getList() },
  methods: {
    getList() { this.loading = true; listAddress(this.queryParam).then(response => { this.list = response.data; this.loading = false }) },
    onSelectChange(selectedRowKeys) { this.selectedRowKeys = selectedRowKeys; this.multiple = !selectedRowKeys.length },
    handleStatusChange(record, checked) { updateAddress({ id: record.id, status: checked ? 1 : 0 }).then(() => { this.$message.success('修改成功'); this.getList() }) },
    handleDelete(row) {
      const that = this
      const ids = row.id || this.selectedRowKeys
      this.$confirm({
        title: '确认删除所选中数据?',
        onOk() {
          let data = []
          if (row.id) { data.push(row.id) } else { that.selectedRowKeys.forEach(id => data.push(id)) }
          return delAddress(data).then(() => { that.onSelectChange([]); that.getList(); that.$message.success('删除成功', 3) })
        }
      })
    }
  }
}
</script>
